import {
    HomeDemo1,
    HomeDemo2,
    HomeDemo3
    
} from '../../utils/allImgs'

const data = [ {img:HomeDemo1,path:'/index-demo-1'} , {img:HomeDemo2,path:'/index-demo-2'} , {img:HomeDemo3,path:'/index-demo-3'} ]

export default data